export default "__VITE_ASSET__B$DnRSKv__"